import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormFieldInfo } from '../../../../models/forms-response.models';
@Component({
    selector: 'app-component-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    formFieldConfig: any;
    name: string
    className: string;

    constructor(private cdref: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
        if (this.formFieldConfig && this.formFieldConfig.displayText) {
            this.name = this.formFieldConfig.displayText;
        }
        else {
            this.name = this.formFieldInfo.defaultValue;
        }
        this.className = this.formFieldInfo.fieldCode;
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    display(){
        let query = <HTMLElement><unknown>document.querySelector(`.${this.className}`)
        return query.innerHTML = this.name;
    }
}